/**
 * Polygon icon SVG component
 * Standard Polygon logo
 */
export function PolygonIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_434_2513)">
        <path
          d="M5.99988 5.17549L4.49996 4.30367L0 6.91893V12.1491L4.49996 14.7644L9.00016 12.1491V4.01301L11.5 2.56022L14.0002 4.01301V6.91893L11.5 8.37172L10.0001 7.50017V9.8245L11.5 10.6963L16 8.08105V2.85089L11.5 0.235626L7.00006 2.85089V10.987L4.49996 12.4398L2.00004 10.987V8.08105L4.49996 6.62827L5.99988 7.49981V5.17549Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_434_2513">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
